import React, { useEffect, type FC } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import { notifyParent } from 'mailup-react-helpers'

import { canViewExportStatus, openExportStatus } from 'Helpers/recipient'
import setMenuItem from 'Helpers/setMenuItem'

import { PageHeader } from 'mailup-web-components'

import { RECIPIENTS_LIST_LABEL } from 'Constants'

const Header: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  useEffect(() => {
    setMenuItem('UnsubscriptionCampaignsList')
  }, [])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
      'data-mu-test': 'breadcrumb-item__recipients',
      onClick: Function.prototype,
    },
    {
      label: intl.formatMessage({ id: RECIPIENTS_LIST_LABEL }),
      'data-mu-test': 'breadcrumb-item__recipients-list',
      url: '#',
      onClick: () => {
        navigate('/recipients/list')
      },
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.UnsubscriptionCampaigns' }),
      'data-mu-test': 'breadcrumb-item__unsubscriptioncampaigns',
      onClick: Function.prototype,
    },
  ]

  const menuItems = [
    {
      label: intl.formatMessage({ id: RECIPIENTS_LIST_LABEL }),
      'data-mu-test': 'topmenu-item__recipients-list',
      onClick: () => {
        navigate('/recipients/list')
      },
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Bounces' }),
      'data-mu-test': 'topmenu-item__recipients-list__bounces',
      onClick: () =>
        notifyParent('redirectMainFrame', [
          'statistics_app_redirector.aspx?r=/stats/bounces/list',
        ]),
    },

    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.UnsubscriptionCampaigns',
      }),
      'data-mu-test': 'topmenu-item__recipients-list__unsubscriptioncampaigns',
      isActive: true,
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.RecipientsOverview' }),
      'data-mu-test': 'topmenu-item__recipients-list__recipients-overview',
      onClick: () => {
        navigate('/recipients/overview')
      },
    },
    canViewExportStatus()
      ? {
          label: intl.formatMessage({ id: 'Load.NavMenu.ExportStatus' }),
          'data-mu-test': 'topmenu-item__recipients-list__export-status',
          onClick: openExportStatus,
        }
      : undefined,
  ].filter((o) => o !== undefined)

  return (
    <PageHeader
      title={intl.formatMessage({ id: 'Load.NavMenu.UnsubscriptionCampaigns' })}
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
    />
  )
}

export default Header
